import { SphereGeometry, MeshBasicMaterial, Mesh, BackSide } from "three";


function createSphere() {

    
    let sphereMaterial = new MeshBasicMaterial({

        color: 0x000000,
        side: BackSide,
        transparent: true,
        opacity: 0.0,
        
    });
    let sphereGeo = new SphereGeometry(1, 10, 10);

    let sphere = new Mesh(sphereGeo, sphereMaterial);

    //sphereMaterial.opacity = 0.0;
    
    // sphere.tick = (delta) => {
    //     sphereMaterial.opacity += 0.1 * delta;
    // };

    document.getElementById("out_in_space").addEventListener("change", function() {

    if (this.value == 100) {
        let dimmTime = setTimeout(() => {
            let dimmInt = setInterval(function(){
                sphereMaterial.opacity += 0.05;
                if(sphereMaterial.opacity >= 1){
                    sphereMaterial.opacity = 0;
                }
                
            }, 100);

            setTimeout(() => { 
                clearInterval(dimmInt); 
            }, 2000);      
            
   
          }, 9000);




          
          
          
        
        }
      

    });
    

    
    
    return sphere;
}
export {createSphere};